/* eslint-disable import/prefer-default-export */
export const REQUEST_GENDERS = 'Catalog/genders/REQUEST_GENDERS';
export const REQUEST_PROVINCES = 'Catalog/locations/states/REQUEST_PROVINCES';
export const REQUEST_TRANSIT_INFO =
  'Catalog/transit/information/REQUEST_TRANSIT_INFO';
export const REQUEST_BRANDS = 'Catalog/vehicles/brands/REQUEST_BRANDS';
export const REQUEST_MODELS = 'Catalog/vehicles/models/REQUEST_MODELS';
export const REQUEST_ADDITIONAL_BROKERS =
  'Catalog/additionalBrokers/REQUEST_ADDITIONAL_BROKERS';
